module.exports = __webpack_public_path__ + "img/intervento.4529d50d.jpeg";